import { registerWorkflowActions } from './actionToSignalMapping';
import { useEffect } from 'react';

export const useRegisterWorkflowActions = workflowActions => {
    useEffect(() => {
        registerWorkflowActions(workflowActions);
    }, []);
};
